import type { Experiment } from 'types';
import { Importance } from './Importance';
import { Hypothesis } from './Hypothesis';
import { Description } from './Description';
import { Screenshots } from './Screenshots';
import { PlanCard } from '../ExperimentPlan';

type ExperimentInfoScreenProps = { experiment: Experiment };

export const ExperimentInfoScreen = ({ experiment }: ExperimentInfoScreenProps) => {
  return (
    <div className="flex flex-col gap-[14px]">
      <div className="grid grid-cols-1 gap-[14px] md:grid-cols-2">
        {/* Stacked in one column: a completed PXL score is much shorter than the
            hypothesis beside it, and the plan fills the space that left. */}
        <div className="flex flex-col gap-[14px]">
          <Importance experiment={experiment} />
          <PlanCard experiment={experiment} />
        </div>
        <Hypothesis experiment={experiment} />
      </div>
      <Description experiment={experiment} />
      <Screenshots experiment={experiment} />
    </div>
  );
};
